module.exports = __webpack_public_path__ + "static/media/bar_api.e14d9995.jpg";